import React, { FC } from 'react';
import { format } from 'date-fns';

import sanityImgUtil from 'utils/sanityImgUtil';
import sanityImgSrcSetUtil from 'utils/sanityImgSrcSetUtil';

import { Img, SocialShareButtons, Base } from 'styled';
import {
  Container,
  Title,
  ImgContainer,
  Body,
  MetaContainer,
  PublishedDate,
} from './style';

import { BlogPost } from 'types';
import { GlobalSettingsReducer as GlobalSettings } from 'state/reducers/globalSettings';

import useLanguage from 'hooks/useLanguage';

interface Props {
  blogPost: BlogPost;
  globalSettings: GlobalSettings;
}

export const HERO_COMPRESSION_VALUE = 85;

const BlogPostHero: FC<Props> = ({ blogPost, globalSettings }) => {
  const { title, heroImage, meta } = blogPost;

  const Language = useLanguage();

  return (
    <Container mb={[1, 1, 1.5]}>
      {heroImage.id && (
        <ImgContainer>
          <Img
            alt={heroImage.alt}
            sizes="(max-width: 768px) 1536px, (max-width: 1440px) 2880px, 1500px"
            src={sanityImgUtil(
              heroImage,
              1536,
              undefined,
              HERO_COMPRESSION_VALUE
            )}
            srcSet={sanityImgSrcSetUtil(
              heroImage,
              1536,
              2880,
              1500,
              HERO_COMPRESSION_VALUE
            )}
            preloadFullWidth={true}
            dimensions={heroImage.metadata?.dimensions}
            crop={heroImage.crop}
          />
        </ImgContainer>
      )}
      <Title>{title}</Title>
      {meta.author && (
        <Body>
          {Language.t('BlogPost.writtenBy', {
            authorName: meta.author.fullName,
          })}
        </Body>
      )}
      <MetaContainer mt={[1.5, 1.5, 0.5]}>
        <PublishedDate as="p" flexDirection={['column', 'column', 'row']}>
          {Language.t('BlogPost.updated')}
          <Base as="span" ml={[0, 0, 0.25]}>
            {format(
              new Date(meta.updatedDate || meta.publishedDate),
              'MMMM d, y'
            )}
          </Base>
        </PublishedDate>
        <SocialShareButtons
          renderBlackIcons={true}
          media={heroImage.src || globalSettings.seo.image.src}
        />
      </MetaContainer>
    </Container>
  );
};

export default BlogPostHero;
